if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    // SLIDERS

    $('.sym-slides').slick({
        accessibility: false
    });
    

    $('.sym-slider').slick({
        accessibility: true,
		fade:true,
        adaptiveHeight: true,
        arrows: true,
        dots: true,    
    });


    // slider hero home
	$('.hero-slides').slick({
        accessibility: false,
		fade:true,
		autoplay :true,
		autoplaySpeed:5000,
		speed:500,
		pauseOnFocus:false,
		pauseOnHover :false,
        arrows:false,
        dots: true,
		responsive: [
			{
			  breakpoint: 1001,
			  settings: {
					arrows:false,
                    dots: true,
			  }
			}
		]
    });


    $('.brands-slides').slick({
        infinite: true,
        slidesToScroll: 2,
		slidesToShow: 5,
        accessibility: false,
        arrows: true,
        dots: false,      
        autoplay: true,
        autoplaySpeed: 4000,
        centerPadding: '20px',
		responsive: [
			{
			  breakpoint: 768,
			  settings: {
                dots: true,     
                slidesToShow: 4,
			  }
			},
			{
			  breakpoint: 601,
			  settings: {
                dots: true,    
                slidesToShow: 3,
			  }
			},
			{
			  breakpoint: 452,
			  settings: {
                dots: true,    
                slidesToShow: 2,
			  }
			}
		]
    });


    // SWIPER
    const swiperClass = ".swiper";
    const swiperOps = {
        createElements: true,
        loop: true,
    };

    document.querySelectorAll(swiperClass).forEach((slider) => {
        const sliderOps = slider.dataset.swiper
        ? JSON.parse(slider.dataset.swiper)
        : {};

        const swiper = new Swiper(
        swiperClass,
        Object.assign({}, swiperOps, sliderOps)
        );
    });


})();